<div class="sidebar-container">
  <div class="sidebar-header">
    <div class="logo_wrapper">
      <a routerLink="/" routerLinkActive="active-link" ariaCurrentWhenActive="page">
        <img [src]="theme.getTheme().logoPath + 'main_logo.svg'" alt="cheaptickets.in" class="img-fluid">
      </a>
    </div>
    <button mat-icon-button aria-label="Close menu" (click)="closeSidebar.emit()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

    @if(authState.isLoggedIn$ | async) {
      <div class="user-profile">
        <div class="avatar">
          @if ((authState.user$ | async)?.profile_img && !imageError) {
            <img [src]="((authState.user$ | async)?.profile_img) | brokenImageUrl" alt="user" (error)="handleImageError()">
          } @else {
            {{ getInitials((authState.user$ | async)?.name) }}
          }
        </div>
        <div class="user-info">
          <h3>Hi, {{(authState.user$ | async)?.name}}</h3>
          <p>Welcome to {{theme.getTheme().siteName}}<br>your ultimate travel companion!</p>
        </div>
      </div>
    } @else {
        <div class="user-profile guest-profile">
          <div class="guest-info">
            <h3>Welcome to {{theme.getTheme().siteName}}</h3>
            <p>Login to manage your flights & trips</p>
            <button mat-flat-button color="primary" class="login-btn" (click)="authSetting()">
              <mat-icon>login</mat-icon>
              Sign In / Log In
            </button>
          </div>
        </div>
    }

  <div class="sidebar-menu">
    @for(item of authProfile; track item.path) {
      <ng-template #menuContent>
        <mat-icon>{{item.icon}}</mat-icon>
        <div class="menu-text">
          <span class="title">{{item.title}}</span>
          <span class="info">{{item.info}}</span>
        </div>
      </ng-template>

      @if(authState.isLoggedIn$ | async) {
        <a [routerLink]="item.path" class="menu-item" routerLinkActive="active" (click)="closeSidebar.emit()">
          <ng-container *ngTemplateOutlet="menuContent"></ng-container>
        </a>
      } @else {
        <a href="javascript:void(0)" class="menu-item" (click)="authSetting()">
          <ng-container *ngTemplateOutlet="menuContent"></ng-container>
        </a>
      }
    }
    <!-- Contact Section -->
    @if(WEBSITE_INFO?.address?.Email || WEBSITE_INFO?.address?.CustomerSupport_phone || WEBSITE_INFO?.address?.CustomerSupport) {
      <div class="contact-section">
        <div class="contact-header">
          <mat-icon>support_agent</mat-icon>
          <h4>Need Help?</h4>
        </div>
        <div class="contact-list">
          @if(WEBSITE_INFO?.address?.Email) {
            <a [href]="'mailto:' + WEBSITE_INFO?.address?.Email" class="contact-link">
              <mat-icon>mail_outline</mat-icon>
              <span>{{WEBSITE_INFO?.address?.Email}}</span>
            </a>
          }
          @if(WEBSITE_INFO?.address?.CustomerSupport_phone) {
            <a [href]="'tel:' + WEBSITE_INFO?.address?.CustomerSupport_phone" class="contact-link">
              <mat-icon>phone_in_talk</mat-icon>
              <span>{{WEBSITE_INFO?.address?.CustomerSupport_phone}}</span>
            </a>
          }
          @if(WEBSITE_INFO?.address?.CustomerSupport) {
            <a [href]="'tel:' + WEBSITE_INFO?.address?.CustomerSupport" class="contact-link">
              <mat-icon>headset_mic</mat-icon>
              <span>{{WEBSITE_INFO?.address?.CustomerSupport}}</span>
            </a>
          }
        </div>
      </div>
    }

    @if(authState.isLoggedIn$ | async) {
      <a href="javascript:void(0)" class="menu-item logout" (click)="logout()">
        <mat-icon>logout</mat-icon>
        <div class="menu-text">
          <span class="title">Logout</span>
        </div>
      </a>
    }
  </div>
</div>
